import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';

interface ResourceLabelsCardProps {
  labels: string[];

  style?: React.CSSProperties;

  onClick?(): void;
}

function ResourceLabelsCard({
  labels,
  style = {},
  onClick,
}: ResourceLabelsCardProps) {
  if (labels.length > 0) {
    return (
      <div
        className={styles.ResourceLabelsCard_hasData}
        onClick={onClick}
        style={style}
      >
        {labels.map((l, li) => {
          return <label key={li}>{l}</label>;
        })}
      </div>
    );
  }

  return (
    <div className={styles.ResourceLabelsCard} onClick={onClick} style={style}>
      {/* <span>添加标签</span> */}
      <span>{FI18n.i18nNext.t('brr_resourcelisting_item_btn_addtags')}</span>
    </div>
  );
}

export default ResourceLabelsCard;
